import { defineMessages } from 'react-intl'

const messages = defineMessages({
  paymentInfo: {
    id: 'global.payment-info',
  },
  changeCreditCard: {
    id: 'global.change-credit-card',
  },
  pendingToPay: {
    id: 'global.pending-pay',
  },
  total: {
    id: 'global.total',
  },
  creditCardUsed: {
    id: 'voucher-credit-card-used',
  },
  payNow: {
    id: 'global.pay-now',
  },
  partialPay: {
    id: 'reservation.partial-pay',
  },
  warningCardExpiredAdd: {
    id: 'global.card-expired-add',
  },
})

export default messages
